'use strict';

var _ = require('lodash');
var $ = require('jquery');
var PubSub = require('tscom-pubsub');

var ModalView = require('standard-vote/app/scripts/views/modal');

module.exports = ModalView.extend({
    events: function(){
        return _.extend({},ModalView.prototype.events,{
            'click .optin-form a': 'handleLinkClick'
        });
    },

    handleLinkClick: function(e) {
        var evt = {
            category: 'Link Click',
            action: 'Link Click: ' + e.target.innerText,
            label: 'Link Click: ' + e.target.innerText
        };

        PubSub.trigger('trackGoogle',evt);
    },

    initialize: function() {
        $('.modal').click(this.onModalClick.bind(this));
    },
    close: function() {
        PubSub.trigger('modal:close');
    },
    onModalClick: function(e) {
        if (e.target.className == 'modal in') {
            PubSub.trigger('modal:close');
        }
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/modal.js